import api from "./api";
import { conditionalHeaders } from "./concurrency";
import type { LibraryLocation, LibraryLocationInput } from "../types";

const ENDPOINT = "/library/locations";

export const libraryLocationService = {
  async list(signal?: AbortSignal): Promise<LibraryLocation[]> {
    return (await api.get<LibraryLocation[]>(ENDPOINT, { signal })).data;
  },
  async create(payload: LibraryLocationInput): Promise<LibraryLocation> {
    return (await api.post<LibraryLocation>(ENDPOINT, payload)).data;
  },
  async update(
    location: LibraryLocation,
    payload: Partial<LibraryLocationInput>
  ): Promise<LibraryLocation> {
    return (
      await api.patch<LibraryLocation>(`${ENDPOINT}/${location.id}`, payload, {
        headers: conditionalHeaders(location.updated_at),
      })
    ).data;
  },
  async remove(location: LibraryLocation): Promise<void> {
    await api.delete(`${ENDPOINT}/${location.id}`, {
      headers: conditionalHeaders(location.updated_at),
    });
  },
};
